import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './Layout'
import './index.css'
import { AuthProvider } from './components/auth/AuthProvider';
import { AccountProvider } from './components/auth/AccountContext'
import { RoleProvider } from './contexts/RoleContext'
import { initializePreloads } from './utils/preloader'

// Configurar basename baseado no ambiente
const basename = import.meta.env.PROD ? '/' : '/';

// Inicializar preloads para melhor performance
initializePreloads();

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Verificar por atualizações
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Nova versão disponível
                if (confirm('Nova versão disponível! Deseja atualizar?')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter
      basename={basename}
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <AccountProvider>
          <RoleProvider>
            <App />
            <Toaster position="top-right" />
          </RoleProvider>
        </AccountProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)

// Inicializar manipulador de erros do Vite após o React render
if (import.meta.env.DEV) {
  import('./utils/viteErrorHandler').then(({ viteErrorHandler }) => {
    viteErrorHandler.initialize();
  });
}
